module.exports = __webpack_public_path__ + "static/1t-da14bc448c5af2aa7b0b84601a83e9ab.jpg";